import React, { Component } from "react";
import { Card, Table, Spin } from "antd";
import Modal from "./Modal";
import ModalEdit from "./ModalEdit";
import ModalDelete from "./ModalDelete";
import coloredRows from "./coloredRows.css";
import { connect } from "react-redux";

import { fetchProduct } from "appRedux/actions/Product";

function confirm(e) {}

function cancel(e) {}
function status(status) {
	if (status == 0) {
		return "Inactivo";
	} else if (status == 1) {
		return "Activo";
	}
}

class Simple extends Component {
	componentDidMount() {
		this.props.fetchProduct();
	}
	setRowClassName = (record) => {
		return record.status_description === "Activo"
			? "active_product"
			: "inactive_product";
	};
	render() {
		const columns = [
			{
				title: "Nombre ",
				dataIndex: "name",
				key: "name",
			},
			{
				title: "Descripción",
				dataIndex: "description",
				key: "description",
				render: (text) => <span>{text}</span>,
			},
			{
				title: "Precio",
				dataIndex: "price",
				key: "price",
			},

			{
				title: "Estado",
				dataIndex: "status_description",
				key: "status_description",
			},
			{
				title: "Acción",
				key: "action",

				render: (text, record) => (
					<span>
						<ModalEdit recording={record} />
						<ModalDelete recording={record} />
					</span>
				),
			},
		];
		const { products } = this.props;
		//console.log(products);

		let usersDecode = [];
		usersDecode = products.map((product) => {
			return {
				id: product.id,
				name: product.name,
				description: product.description,
				status: product.status,
				status_description: status(product.status),
				price: product.price,
				category_id: product.category_id,
				urlVideo: product.url_video,
			};
		});

		if (usersDecode == 0) {
			return <Spin className="gx-loader-container" />;
		}

		return (
			<Card title="Productos">
				<Modal />
				<br />
				<Table
					className="gx-table-responsive"
					columns={columns}
					dataSource={usersDecode}
					rowClassName={this.setRowClassName}
				/>
			</Card>
		);
	}
}

function mapStateToProps({ products }) {
	return {
		products,
	};
}

export default connect(mapStateToProps, { fetchProduct })(Simple);



// WEBPACK FOOTER //
// ./src/routes/main/Products/Table.js